function NoPage() {
    return (
      <>
        404 !!!
      </>
    );
  }
  
  export default NoPage;